import React from 'react';
import {Field} from 'react-final-form';
import {FormFieldText} from '@yandex-data-ui/cloud-components';

import {ComputeFormFieldsValues} from 'components/calculator/ComputeFormFields/ComputeFormFields';
import {FormFieldRangeInputPicker} from 'components/formFields';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import {getMemoryProps} from 'components/calculator/ComputeFormFields/utils';
import {ComputeConfig} from 'components/calculator/models';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {fromBytes} from 'utils';

interface MemoryFieldProps extends WithTranslationProps {
    name: string;
    platforms: ComputeConfig['platforms'];
    osProducts: ComputeConfig['osProducts'];
    values: ComputeFormFieldsValues;
    disabled?: boolean;
}

const MemoryField: React.FC<MemoryFieldProps> = (props) => {
    const {name, platforms, osProducts, disabled, values, i18nK, i18n} = props;

    const fieldName = `${name}memory`;
    const memoryProps = getMemoryProps({platforms, osProducts}, values, i18n);

    return (
        <CalculatorFormLayout.Row title={i18nK('field_memory')} note={i18nK('context_memory')}>
            {disabled ? (
                <Field
                    name={fieldName}
                    format={(value: string) =>
                        `${fromBytes(Number(value), 'gb')} ${i18n('common', 'label_unit-gigabyte')}`
                    }
                >
                    {(fieldProps) => <FormFieldText {...fieldProps} size="l" disabled={true} />}
                </Field>
            ) : (
                <Field name={fieldName}>
                    {(fieldProps) => (
                        <FormFieldRangeInputPicker {...fieldProps} {...memoryProps} size="l" />
                    )}
                </Field>
            )}
        </CalculatorFormLayout.Row>
    );
};

export default withTranslation('calculator')(MemoryField);
